import { useEffect, useRef, useState } from 'react'
import { getScrollLimitY } from '../helpers'

export function useShowHeader(isOpen) {
    const prevScrollPosRef = useRef(0)
    const [isVisible, setIsVisible] = useState(true)

    const scrollLimitY = getScrollLimitY()

    const handleScroll = () => {
        const currentScrollPos = window.scrollY
        const visible = prevScrollPosRef.current > currentScrollPos || currentScrollPos < scrollLimitY

        prevScrollPosRef.current = currentScrollPos

        if (isVisible !== visible) setIsVisible(visible)
    }

    useEffect(() => {
        if (isOpen) setIsVisible(true)

        window.addEventListener('scroll', handleScroll)

        return () => window.removeEventListener('scroll', handleScroll)
    }, [isVisible, isOpen])

    return { isVisible }
}
